import { render, staticRenderFns } from "./DestaqueDaTrocaDeTela.vue?vue&type=template&id=466f780e&scoped=true&"
import script from "./DestaqueDaTrocaDeTela.vue?vue&type=script&lang=ts&"
export * from "./DestaqueDaTrocaDeTela.vue?vue&type=script&lang=ts&"
import style0 from "./DestaqueDaTrocaDeTela.vue?vue&type=style&index=0&id=466f780e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "466f780e",
  null
  
)

export default component.exports